import React, { useEffect, useState, memo } from 'react'
import { Box, Checkbox, Skeleton } from '@mui/material'
import {
  checkboxChecked,
  checkboxUnchecked,
} from '../../../../assets/images/icons'
import { MuiImage } from '../../../../components'
import { useGlobalStore } from '../../../../store'
import { ROLES_CLIENT } from '../../../../constants'
import { showCustomDevTool } from '../../../../util'

import {
  FormGroupLabelWrap,
  Heading,
  SubHeading,
  SubLHSItem,
  SubLHSWrap,
} from './styles'

const Listing = ({ className, isLoading, data, onChange, lhsItem, subLhsArray }) => {
  const {user, projectIdValue} = useGlobalStore()

  if (data.length === 0) return false
  // BELOW IS THE CODE TO HIDE SNAPSHOT FROM THE CLIENT IF NOT HAVING EXCESS
  const listData = (ROLES_CLIENT.includes(user.UserType) && !projectIdValue.IsSnapshotEnabled) ? data.filter(f => f.InsightsElementType !== 'Snapshot') : data
  const showCustomDevToolFlag = showCustomDevTool('dev')

  return (
    <Box>
      <Heading>{isLoading ? <Skeleton width={160} /> : lhsItem?.title} 
      {showCustomDevToolFlag && (
        <span style={{ fontSize: '10px', color: '#000', width: '100%' }}>
          <br />TabId:{lhsItem.TabId}
        </span>
      )}
      </Heading>
      <SubLHSWrap>
        {listData.map((subLHSItem, jIndex) => {
          const isPresent = subLhsArray.find(
            (item) => item.InsightsElementId === subLHSItem.InsightsElementId
          )
          return (
            <React.Fragment key={'content_' + jIndex}>
              {subLHSItem.groupName && (
                <SubHeading key={'subHeadingL1_' + jIndex}>{subLHSItem.groupName}</SubHeading>
              )}
              <SubLHSItem key={'contentL1_' + jIndex} showCustomDevTool={showCustomDevToolFlag}>
                {isLoading ? (
                  <Box sx={{ display: 'flex' }}>
                    <Skeleton width={15} sx={{ marginRight: '10px' }} />
                    <Skeleton width={110} />
                  </Box>
                ) : (
                  <>
                    <FormGroupLabelWrap
                      label={subLHSItem.Title}
                      onChange={() => onChange(subLHSItem)}
                      control={
                        <Checkbox
                          icon={<MuiImage src={checkboxUnchecked} width='14px' />}
                          checkedIcon={<MuiImage src={checkboxChecked} width='14px' />}
                          checked={!!isPresent}
                        />
                      }
                    />
                    {showCustomDevToolFlag && (
                      <span style={{ fontSize: '10px', color: '#000' }}>
                        id:{subLHSItem.InsightsElementId}<br />
                        type:{subLHSItem.InsightsElementType}
                      </span>
                    )}
                  </>
                )}
              </SubLHSItem>
            </React.Fragment>
          )
        })}
      </SubLHSWrap>
    </Box>
  )
}

export default memo(Listing)
